import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, HandshakeIcon } from 'lucide-react';
const supplierLogos = [259, 258, 257, 256, 255, 254, 253, 252, 251, 250, 249, 248, 247, 246, 245, 244, 243, 242, 241, 240, 239, 238, 237, 236, 235, 234, 233, 232, 231, 230, 229, 228, 227, 226, 225, 224, 223, 222, 221, 220, 219, 218, 217, 216, 215, 214, 213, 212, 211, 210, 209, 208, 207, 206, 205, 204, 203, 202, 201, 200, 199, 198, 176, 177, 178, 179, 180, 181, 183, 184, 189, 188, 185, 186, 182, 187, 190, 191, 192, 193, 194, 195, 196, 197, 175, 174, 173, 172, 171, 170, 169, 168, 167, 166, 165, 164, 163, 162, 161, 160, 159, 158, 157, 156, 155, 154, 152, 151, 150, 149, 148, 147, 146, 145, 144, 143, 142, 141, 140, 139, 138, 137, 136, 135, 134, 133, 132, 131, 130, 129, 128, 127, 126, 125, 124, 123, 122, 121, 120, 119, 118, 117, 116, 115, 114, 113, 112, 111, 110, 109, 108, 107, 106, 105, 104, 102, 101, 100, 99, 98, 97, 96, 95, 94, 93, 92, 91, 90, 89, 88, 87, 86, 85, 84, 83, 82, 81, 80, 79, 78, 77, 76, 75, 74, 73, 72, 71, 70, 69, 68, 67, 66, 65, 64, 63, 62, 61, 60, 59, 57, 56, 55, 54, 53, 52, 51, 50, 49, 48, 47, 46, 45, 44, 43, 42, 41, 40, 39, 38, 37, 36, 35, 34, 32, 31, 30, 29, 28, 27, 26, 25, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, '09', '08', '07', '06', '05', '04', '03'].map(n => `https://ambienttelecom.com/wp-content/uploads/2024/09/Supplier20Logos-${n}.png`);
const allLogos = [...supplierLogos, 'https://ambienttelecom.com/wp-content/uploads/2024/09/Supplier20Logos-24-1.png', 'https://ambienttelecom.com/wp-content/uploads/2024/08/360.webp', 'https://ambienttelecom.com/wp-content/uploads/2024/03/Supplier-Logos-01.webp'];
function SupplierLogo({
  src,
  index
}: {
  src: string;
  index: number;
}) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  if (failed) return null;
  return <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: loaded ? 1 : 0,
    scale: loaded ? 1 : 0.9
  }} transition={{
    duration: 0.3,
    delay: Math.min(index * 0.01, 0.5)
  }} className="bg-white rounded-xl border border-slate-100 p-4 flex items-center justify-center aspect-[3/2]" data-id="element-850">
      <img src={src} alt={`Supplier partner ${index + 1}`} className="max-w-full max-h-full object-contain" loading="lazy" onLoad={() => setLoaded(true)} onError={() => setFailed(true)} data-id="element-851" />
    </motion.div>;
}
export function SuppliersPage({
  onNavigate
}: {
  onNavigate: (page: string) => void;
}) {
  return <div data-id="element-852">
      {/* Hero */}
      <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-24 overflow-hidden bg-slate-900" data-id="element-853">
        <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-854"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900/90" data-id="element-855"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/4 w-[600px] h-[600px] bg-cyan-500/12 rounded-full blur-[120px] pointer-events-none" data-id="element-856"></div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-857">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-858">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-859">
              <span className="flex h-2 w-2 rounded-full bg-cyan-400 mr-2" data-id="element-860"></span>
              Trusted Partnerships
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6 tracking-tight" data-id="element-861">
              Our Suppliers
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-862">
              We partner with trusted vendors who provide the high-quality
              telecom services you deserve. Their commitment to excellence
              ensures we can consistently deliver the best rates and solutions
              for your business.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-white border-b border-slate-100" data-id="element-863">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-864">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center" data-id="element-865">
            {[{
            value: '240+',
            label: 'Supplier Partners'
          }, {
            value: 'Nationwide',
            label: 'Coverage Area'
          }, {
            value: 'Best Rates',
            label: 'Guaranteed Pricing'
          }].map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} data-id="element-866">
                <div className="text-2xl md:text-3xl font-extrabold text-primary" data-id="element-867">
                  {stat.value}
                </div>
                <div className="text-slate-500 font-medium mt-1" data-id="element-868">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Logo Grid */}
      <section className="py-16 bg-slate-50" data-id="element-869">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-870">
          <div className="text-center mb-12" data-id="element-871">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-872">
              Trusted by the Best in Telecom
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-873">
              We work with over 240 providers to ensure you always get the most
              competitive rates and the best service quality.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" data-id="element-874">
            {allLogos.map((logo, i) => <SupplierLogo key={i} src={logo} index={i} data-id="element-875" />)}
          </div>
        </div>
      </section>

      {/* Why We Partner */}
      <section className="py-20 bg-white" data-id="element-876">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-877">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-878">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-879">
              <div className="w-14 h-14 bg-primary/10 rounded-2xl flex items-center justify-center mb-6" data-id="element-880">
                <HandshakeIcon className="w-7 h-7 text-primary" data-id="element-881" />
              </div>
              <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-882">
                Why We Partner with Multiple Providers
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-883">
                By maintaining relationships with hundreds of telecom providers,
                we can objectively compare rates and services to find the
                absolute best deal for your business — something no single
                carrier can offer.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-884">
                Our vendor-neutral approach means we always recommend what's
                best for you, not what's best for a carrier's bottom line.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="grid grid-cols-2 gap-4" data-id="element-885">
              {[{
              value: '30%+',
              desc: 'Average savings found'
            }, {
              value: '100%',
              desc: 'Vendor neutral'
            }, {
              value: '24/7',
              desc: 'Support coverage'
            }, {
              value: 'Free',
              desc: 'Bill analysis'
            }].map((item, i) => <div key={i} className="bg-slate-50 rounded-2xl p-6 text-center border border-slate-100" data-id="element-886">
                  <div className="text-2xl font-extrabold text-primary mb-1" data-id="element-887">
                    {item.value}
                  </div>
                  <div className="text-sm text-slate-600" data-id="element-888">{item.desc}</div>
                </div>)}
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-primary relative overflow-hidden py-20" data-id="element-889">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-890">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl" data-id="element-891"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white opacity-10 rounded-full blur-3xl" data-id="element-892"></div>
        </div>

        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-893">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-894">
            Let us find the best provider for your business
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-895">
            With access to hundreds of suppliers, we'll match you with the
            perfect telecom solution at the best possible price.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-896">
            <button onClick={() => onNavigate('home')} className="w-full sm:w-auto bg-white text-primary hover:bg-slate-50 px-8 py-4 rounded-full font-bold text-lg transition-colors shadow-lg inline-flex items-center justify-center" data-id="element-897">
              Get Your Free Analysis
              <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-898" />
            </button>
            <a href="tel:+4105255284" className="w-full sm:w-auto bg-transparent border-2 border-white text-white hover:bg-white/10 px-8 py-4 rounded-full font-bold text-lg transition-colors" data-id="element-899">
              Call Us: +410-525-5284
            </a>
          </div>
        </div>
      </section>
    </div>;
}